export default [
    {
        title: 'Document',
        customIcon: 'DocumentSVG',
        children: [
            {
                title: 'Campaign List',
                route: 'campaign-list',
                path: '/campaign/list',
            }
        ]
    }
]